<template>
    <section class="accountAuth">
        <Nav title="账户认证" />
		<section v-if="authStatus==-1"></section>
		<section class="no_over" v-else-if="authStatus==0">
			<div class="form">
                <van-field v-model="form.name" label="姓名" :left-icon="imgs.nameIcon" placeholder="请输入个人真实姓名" :disabled='Boolean(form.name)' />
				<van-field v-model="form.idCardNumber" label="身份证号" :left-icon="imgs.cartIcon" placeholder="请输入个人身份证号" />
				<div class="upload_card">
                    <div class="img_box">
						<div class="img_file">
							<img v-if="form.idCardBackPhoto" :src="form.idCardBackPhoto" class="oss_img">
							<img v-else :src="imgs.renxiangIcon" class="upload_bg">
							<van-icon name="cross" v-if="form.idCardBackPhoto"  @click="delImg('idCardBackPhoto')"/>
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange1($event, 'idCardBackPhoto')" ref="file1">
						</div>
						<p class="tit">身份证人像面照片</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.idCardFrontPhoto" :src="form.idCardFrontPhoto" class="oss_img">
							<img v-else :src="imgs.renxiangIcon" class="upload_bg">
							<van-icon name="cross" v-if="form.idCardFrontPhoto" @click="delImg('idCardFrontPhoto')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange2($event, 'idCardFrontPhoto')" ref="file2">
						</div>
						<p class="tit">身份证国徽面照片</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.officeEnvironmentPhoto" :src="form.officeEnvironmentPhoto" class="oss_img">
							<img v-else :src="imgs.shouchiIcon" class="upload_bg">
							<van-icon name="cross" v-if="form.officeEnvironmentPhoto" @click="delImg('officeEnvironmentPhoto')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange3($event, 'officeEnvironmentPhoto')" ref="file3">
						</div>
						<p class="tit">真人办公环境合照</p>
					</div>
					<div class="img_box">
						<div class="img_file">
							<img v-if="form.employmentProofPhoto" :src="form.employmentProofPhoto" class="oss_img">
							<img v-else :src="imgs.shouchiIcon" class="upload_bg">
							<van-icon name="cross" v-if="form.employmentProofPhoto" @click="delImg('employmentProofPhoto')" />
							<input v-else accept="image/jpg,image/jpeg,image/png" type="file" @change="fileChange4($event, 'employmentProofPhoto')" ref="file4">
						</div>
						<p class="tit">工作证明照片</p>
					</div>
				</div>
			</div>
			<div class="bottom_btn">
				<van-button type="primary" @click="submitForm">提交认证</van-button>
			</div>
		</section>
		<section class="underway" v-else-if="authStatus==1">
			<img src="../../../assets/img/underway.png">
			<p>认证中，1个工作日内完成</p>
		</section>
		<section class="pass" v-else-if="authStatus==2">
			<img src="../../../assets/img/pass.png">
			<p>账户认证通过</p>
		</section>
		<section class="fail" v-else-if="authStatus==3">
			<img src="../../../assets/img/fail.png">
			<p>账户认证失败</p>
			<span v-html="msg" class="msg"></span>
			<van-button round type="danger" class="danger-button" @click="alignFn">重新认证</van-button>
		</section>
	</section>
</template>

<script>

import settingServer from "api/setting";

import Nav from "components/Nav";
import cityIcon from 'assets/img/city.png'
import companyIcon from 'assets/img/company.png'
import cartIcon from 'assets/img/cart.png'
import nameIcon from 'assets/img/name.png'
import gongpaiIcon from 'assets/img/gongpai.png'
import guohuiIcon from 'assets/img/guohui.png'
import shouchiIcon from 'assets/img/shouchi.png'
import renxiangIcon from 'assets/img/renxiang.png'

import { Notify } from 'vant';


export default {
    name: "accountAuth",
    components: {
        Nav,
    },
    data() {
        return {
			authStatus: -1,
			imgs: {
				cityIcon,
				companyIcon,
				cartIcon,
				nameIcon,
				gongpaiIcon,
				guohuiIcon,
				shouchiIcon,
				renxiangIcon,
			},
			form:{
				name: '',
                idCardNumber: '',
				idCardBackPhoto: '',
				idCardFrontPhoto: '',
                officeEnvironmentPhoto: '',
				employmentProofPhoto: '',
			},

			msg: '',
			canSubmit: true,
		};
    },
    created() {
        this.authStatus = this.$route.params.authStatus
        if (this.authStatus == 3) {
		    this.getInfo()
        }

        if(localStorage.getItem('accountInfoJSONString')) {
            this.form.name = JSON.parse(localStorage.getItem('accountInfoJSONString')).name
        }
	},
    methods: {
		getInfo() {
            //获取最新的认证审核记录
			settingServer.getLastestAccountAuthAudit().then((res) => {
				this.msg = res.data.auditOpinion.replace(/\n/g, '<br>')
			})
		},
		alignFn() {
			this.authStatus = 0
		},
		fileChange1 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 1)
		},
		fileChange2 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 2)
		},
		fileChange3 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 3)
		},
		fileChange4 (e, type) {
            let file = e.target.files[0];
			this.uploadOss(file, type, 4)
		},
		uploadOss(file, type, num) {
			if(file.size/1024/1024>10){
				if(num ==1){
					this.$refs.file1.value = null
				}else if (num == 2) {
					this.$refs.file2.value = null
				}else if (num == 3) {
					this.$refs.file3.value = null
				}else if (num == 4) {
					this.$refs.file4.value = null
				}
				Notify({ type: 'danger', message: '图片不能大于10M' })
				return
			}   
			let	params = new FormData()
			params.append('file', file)
			settingServer.upload(params).then((res) => {
				this.form[type] = res.data
			}).catch((err) => {
			})
		},

		delImg(type) {
			this.form[type]= ''
		},

        checkIdcard(str) {
			var re = /^[1-9]\d{5}(?:18|19|20)\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\d|30|31)\d{3}[\dXx]$/
			if (re.test(str)) {
				return true
			} else {
				return false
			}
		},
        
		submitForm() {
			if(!this.canSubmit) return

            if (!this.form.name) return Notify({ type: 'danger', message: '请填写真实姓名' })
			if (!this.checkIdcard(this.form.idCardNumber)) return Notify({ type: 'danger', message: '请填写正确的身份证号' })

			if (!this.form.idCardBackPhoto) return Notify({ type: 'warning', message: '请上传身份证人像面照片' })
			if (!this.form.idCardFrontPhoto) return Notify({ type: 'warning', message: '请上传身份证国徽面照片' })
			if (!this.form.officeEnvironmentPhoto) return Notify({ type: 'warning', message: '请上传真人办公环境合照' })
			if (!this.form.employmentProofPhoto) return Notify({ type: 'warning', message: '请上传工作证明照片' })

			this.canSubmit = false

			settingServer.accountAuth(this.form).then((res) => {
				this.authStatus = 1
			}).catch(() => {
				this.canSubmit = true
			})
		},

		backFn() {
			this.$router.go(-1)
		},
	},
};
</script>

<style lang="scss">
.accountAuth {
	padding-top: 46px;
	padding-bottom: 80px;
	.no_over {
		.form {
			background: #fff;

			.van-cell {
				align-items: center;
			}

			.van-icon {
				img {
					width: 14px;
				}
			}
			.van-cell__title, .van-field__control {
				color: #2b2f3a;
				font-size: 16px;
			}
			.van-field__label {
				width: 68px;
			}
			.van-icon-arrow {
				color: #575E72;
			}
			.upload_card {
				padding: 19px 18px;
				padding-bottom: 0;
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				.img_box {
					.img_file {
						position: relative;
						width: 159px;
						height: 93px;
					}
					input {
						position: absolute;
						top: 0;
						left: 0;
						z-index: 2;
						width: 100%;
						height: 100%;
						opacity: 0;
					}
					img, video{
						width: 159px;
						height: 93px;
					}
					.oss_img {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.upload_bg {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
					}
					.van-icon {
						position: absolute;
						top: 0;
						right: 0;
						width: 20px;
						height: 20px;
						line-height: 18px;
						padding-left: 6px;
						background-color: rgba(0, 0, 0, 0.7);
						border-radius: 0 0 0 20px;
						color: #fff;
					}
					.tit {
						text-align: center;
						color: #575F72;
						font-size: 15px;
						padding-top: 13px;
						margin-bottom: 26px;
					}
				}
			}
		}
		.authorization {
			font-size: 14px;
			color: #0E88FC;
			padding-left: 19px;
			padding-top: 12px;
		}
		.model_class {
			.van-picker__confirm {
				font-size: 14px;
				color: #2b2f3a;
			}
			.van-hairline--bottom::after {
				border: 0;
			}
			.van-picker__cancel {
				color: #575f72;
			}
		}
		.bottom_btn{
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			.van-button--primary {
				width: 100%;
				height: 56px;
				border-radius: 4px;
				border: 0;
				font-size: 16px;
				font-weight: bold;
				color: #FFFFFF;
				border-radius: 0;
				background: #055ce8;

			}
		}
	}
	.underway {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		img {
			width: 231px;
		}
		p {
			position: absolute;
			bottom: 6px;
			left: 0;
			width: 100%;
			text-align: center;
			font-size: 16px;
			color: #575E72;
		}
	}
	.pass {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		width: 100%;
		text-align: center;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			text-align: center;
			padding-top: 34px;
		}
	}
	.fail {
		position: fixed;
		top: 50%;
		left: 50%;
		transform: translate(-50%,-50%);
		text-align: center;
		width: 100%;
		img {
			width: 157px;
		}
		p {
			color: #2B2F3A;
			font-size: 17px;
			font-weight: bold;
			padding-top: 34px;
			width: 80%;
			margin: 0 auto;
		}
		.msg {
			width: 80%;
			display: block;
			margin: 0 auto;
			color: #575F72;
			font-size: 15px;
			padding-top: 4px;
			text-align: left;
			display: flex;
			justify-content: center;
			background: #EFF0F4;
			border-radius: 8px;
			margin-top: 16px;
			padding: 21px 0;
			line-height: 26px;
		}
		.van-button--danger {
			margin-top: 50px;
			width: 217px;
			height: 46px;
			background: #3A5EEC;
			.van-button__text {
				color: #fff;
				padding-top: 0;
				background: transparent;
			}
			
		}

	}

}
</style>


// WEBPACK FOOTER //
// src/views/setting/auth/AccountAuth.vue